import { render, staticRenderFns } from "./customBooleanKendoGridComponent.vue?vue&type=template&id=22f1147d&"
import script from "./customBooleanKendoGridComponent.vue?vue&type=script&lang=js&"
export * from "./customBooleanKendoGridComponent.vue?vue&type=script&lang=js&"
import style0 from "./customBooleanKendoGridComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports